import AddCategory from "components/features/Forms/AddCategory";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Header, List, Menu, Message, Modal, Segment } from "semantic-ui-react";

function Categories() {
	const { allCategories } = useSelector((state) => state.categories);

	const [openAddModal, setOpenAddModal] = useState(false);

	return (
		<>
			<Menu
				borderless
				style={{ position: "sticky", top: "0px", zIndex: "99" }}
			>
				<Menu.Item>
					<Header as="h3" content="Categories" />
				</Menu.Item>
			</Menu>

			<Segment
				basic
				style={{
					paddingRight: "0px",
					paddingLeft: "0px",
				}}
			>
				<List
					style={{
						borderTop: "1px solid lightgrey",
						borderBottom: "1px solid lightgrey",
					}}
				>
					{!allCategories.length ? (
						<Message
							attached="bottom"
							content="No Category found."
						/>
					) : null}
					{allCategories.map((item) => (
						<List.Item
							style={{
								padding: "15px 10px",
								textTransform: "capitalize",
								borderBottom: "1px solid lightgrey",
							}}
							key={item._id}
						>
							<List.Header content={item.name} />
						</List.Item>
					))}
					<List.Item
						as="a"
						onClick={() => setOpenAddModal(true)}
						style={{ padding: "15px 10px" }}
					>
						<List.Icon name="add" color="green" />
						Add new category
					</List.Item>
				</List>
			</Segment>
			<Modal
				open={openAddModal}
				onClose={() => setOpenAddModal(false)}
				closeOnEscape
			>
				<Segment basic>
					<AddCategory />
				</Segment>
			</Modal>
		</>
	);
}

export default Categories;
